const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class InternationalNegotiations extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.InternationalNegotiations,
            "The civilization revealing this event chooses 3 food, 3 resources, or 3 science and the strongest takes that from the weakest. You cannot choose something the weakest does not have at least 3 of.",
            {}
        )
    }
}

module.exports = InternationalNegotiations;